module.exports = __webpack_public_path__ + "media/img/auth-side-cover-brand-656890af84db5f1119ab5bf08b8115ba.svg";